module.exports = __webpack_public_path__ + "img/user.5f171dd8.svg";